import { IoCalendarOutline } from "react-icons/io5";
import Man from "../../../assest/man.png";

// * The Banner component renders a banner with the current date,
// * a greeting, and a short description.
const Banner = () => {
  let date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  return (
    <div className="banner-box">
      <div className="banner-box-header">
        <img src={Man} alt="logo" />
      </div>
      <div className="banner-box-content">
        <div className="banner-box-content-time">
          <IoCalendarOutline />
          <p>{`${day}/${month}/${year}`}</p>
        </div>
        <div className="banner-box-content-title">
          <h1>Welcome</h1>
        </div>
        <div className="banner-box-content-description">
          <p>Explore the world of events and connect with your friends.</p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
